import { API_CARD_ROOT_ENDPOINT } from "./constants"
import { api } from "../api"
import { convertObjectKeysToCamelCase } from "../../utils/helpers"

/* DEMO DATA */
/* [{"User":{"UserID":10,"EMail":"testuser@aquaexpert.se","FirstName":"TestUser","LastName":"Test","Address":"123TestStreet","Role":0,"ResellerName":null},"Cards":[{"CardIndex":61,"CardId":"LAA2ABhRMzIyNjA0AAAAAA==","UserId":10,"Hwver":1,"Swver":136,"SerialNo":0,"ModelName":"","CardName":"","Hwmodel":0,"Status":0},{"CardIndex":63,"CardId":"PwA1AAVRMzEzMjc0AAAAAA==","UserId":10,"Hwver":1,"Swver":135,"SerialNo":0,"ModelName":"","CardName":"","Hwmodel":0,"Status":0},{"CardIndex":67,"CardId":"IQA1ABhRMzIyNjA0AAAAAA==","UserId":10,"Hwver":1,"Swver":137,"SerialNo":0,"ModelName":"","CardName":"","Hwmodel":0,"Status":1}]},{"User":{"UserID":130,"EMail":"testuser2@aquaexpert.se","FirstName":"Test","LastName":"User2","Address":"TestAddress 123","Role":0,"ResellerName":null},"Cards":[{"CardIndex":64,"CardId":"RwAxAAVRMzEzMjc0AAAAAA==","UserId":130,"Hwver":1,"Swver":135,"SerialNo":0,"ModelName":"","CardName":"","Hwmodel":0,"Status":0},{"CardIndex":65,"CardId":"LQA2ABhRMzIyNjA0AAAAAA==","UserId":130,"Hwver":1,"Swver":135,"SerialNo":0,"ModelName":"","CardName":"","Hwmodel":0,"Status":0},{"CardIndex":66,"CardId":"IgA1ABhRMzIyNjA0AAAAAA==","UserId":130,"Hwver":1,"Swver":135,"SerialNo":0,"ModelName":"","CardName":"","Hwmodel":0,"Status":0}]}] */

export const fetchAllPrograms = async (metaData) => {
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_all_programs`, metaData)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return convertObjectKeysToCamelCase(data)
    } catch (err) {
        //throw err
    }
}

export const writeProgram = async (metaData, currentProgram) => {
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/write_program`, {
            metaData,
            currentProgram
        })

        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        return true
    } catch (err) {
        console.error("Error fetching card data:", err)
        //throw err
    }
}

export const runProgram = async (metaData, program) => {
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/run_program`, {
            metaData,
            programID: program.id
        })

        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        return true
    } catch (err) {
        console.error("Error fetching card data:", err)
        //throw err
    }
}

export const deleteProgram = async (metaData, program) => {
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/delete_program`, {
            metaData,
            programID : program.id
        })
        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        return true
    } catch (err) {
        console.error("Error fetching card data:", err)
       // throw err
    }
}

export const abortProgram = async (metaData) =>
{
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/abort_program`,
            metaData
        )
        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        return true
    } catch (err) {
        console.error("Error executing task:", err)
       // throw err
    }
}

export const stepProgram = async (metaData) => {
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/step_program`,
            metaData
        )
        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        return true
    } catch (err) {
        console.error("Error executing task:", err)
       // throw err
    }
}

    export const fetchProgramState = async (metaData) => {
        try {
            const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_program_state`, metaData)

            if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
                return res.status
            const data = await res.json()
            return convertObjectKeysToCamelCase(data)
        } catch (err) {
           // throw err
        }
    }

export const setValveMode = async (selector) => {
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/set_valve_mode`,
            selector
        )
        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        return true
    } catch (err) {
        console.error("Error executing task:", err)
       // throw err
    }
}
